import { create } from "zustand";
import { TPhaseData } from "../types/phase";

interface MultiAssetStore {
	phase: TPhaseData | null;
	setPhase: (phase: TPhaseData) => void;
	searchValue: string;
	setSearchValue: (searchValue: string) => void;
	selectedFilters: any;
	setSelectedFilters: (filters: any) => void;
	hideExcluded: boolean;
	setHideExcluded: (hide: boolean) => void;
}

export const useMultiAssetStore = create<MultiAssetStore>()((set) => ({
	phase: null,
	setPhase: (phase: TPhaseData) => set({ phase }),
	searchValue: "",
	setSearchValue: (searchValue: string) => set({ searchValue }),
	selectedFilters: {},
	setSelectedFilters: (selectedFilters: any) => set({ selectedFilters }),
	hideExcluded: true,
	setHideExcluded: (hideExcluded: boolean) => set({ hideExcluded }),
}));
